import PropTypes from 'prop-types';
export const responseType = {
  comment: PropTypes.string.isRequired
};
export const responsesType = PropTypes.arrayOf(PropTypes.shape(responseType));
export const reviewType = {
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  sourceId: PropTypes.oneOf(['GOOGLE_PLACES']).isRequired,
  responses: responsesType,
  centreTitle: PropTypes.string
};
export const reviewsType = PropTypes.arrayOf(PropTypes.shape(reviewType));